import type { SquirrelEvents } from "../types/sqrl";

import { SEARCH_BOX_ACTION, SQRL_EVENT } from "../types/sqrl/constants";
import { SEMANTIC_TRACKING_VALUE, TRACK_LABEL } from "../types/constants";
import { TrackingEvent } from "./TrackingEvent";

export class SqrlEvent {
  static close() {
    window.o_global.events<SquirrelEvents>().emit(SQRL_EVENT.SEARCH_CLOSE);
  }

  static open() {
    window.o_global.events<SquirrelEvents>().emit(SQRL_EVENT.SEARCH_OPEN);
  }

  static sendClickEventToTracking() {
    TrackingEvent.track({
      [TRACK_LABEL.SEARCH_BOX_ACTION]: SEARCH_BOX_ACTION.CLICK,
    });
  }

  static sendCharEventToTracking() {
    TrackingEvent.track({
      [TRACK_LABEL.SEARCH_BOX_ACTION]: SEARCH_BOX_ACTION.CHAR,
    });
  }

  static sendSuggestEventToTracking(searchTerm: string, position: string) {
    TrackingEvent.track({
      [TRACK_LABEL.SUGGEST_ADOPT_TERM]: searchTerm,
      [TRACK_LABEL.SUGGEST_ADOPT_POSITION]: position,
    });
  }

  static sendSemanticEventToTracking(value: SEMANTIC_TRACKING_VALUE) {
    TrackingEvent.track({
      [TRACK_LABEL.SUGGEST_METHOD_ACTION]: value,
    });
  }
}
